angular.module('wbDashboard').controller('StyleGuideControllerAurea',
['$scope', 'Misc', 'NgTableParams', '$uibModal', '$timeout', '$window', 'ThinkingService', 'Message',
    function ($scope, Misc, NgTableParams, $uibModal, $timeout, $window, ThinkingService, Message) {

        $scope.forms = {};
        $scope.formData = {
            flashType: 'primary',
            flashTime: 5
        };

        $scope.pageData = {
            nav: { collapse: true },
            sending: false,
            errorMsg: null,
            darken: false,
            thinking: true,
        };
        $scope.options = {
            select: [
                'Option1', 'Another', 'And more', 'Short', 'Much longer option here',
                'Tny', 'Option ABC', 'Option 123', 'Do Re Mi', 'Come on'
            ],
            colors:  ["primary", "gold", "secondary", "success", "danger", "info", "warning", "light", "dark"],
            themeLevels: [],
            odometer: {
                initial: 100000,
                // theme: 'default',
                duration: 30000
            }
        };

        $scope.fromCharCode = String.fromCharCode;

        for (var i = -10; i <= 10; i++) {$scope.options.themeLevels.push(i);}

        // $scope.options.occupation = Misc.occupations;
        // $scope.options.income = Misc.income_levels;
        // $scope.options.accountType = Misc.bank_account_types;
        // $scope.options.state = Misc.states;
        // $scope.options.suffixes = Misc.suffixes;

        $scope.selected = {
            color: $scope.options.colors[0]
        };

        var currentDate = moment().endOf('day').startOf('second');
        $scope.dateRangePicker = {
            date: {startDate: moment("2015-10-20"), endDate: moment().clone().subtract(1,'week').endOf('day').startOf('second')},
            options: {
                pickerClasses: 'dark',
                applyButtonClasses: 'btn-primary',
                cancelButtonClasses: 'btn-outline-primary',
                alwaysShowCalendars: true,
                linkedCalendars: false,
                showDropdowns: true,
                locale: {
                    format: "MM-DD-YYYY", //will give you 2017-01-06
                    applyLabel: "Filter",
                    cancelLabel: 'Cancel',
                    customRangeLabel: 'Custom',
                    daysOfWeek: ["S", "M", "T", "W", "T", "F", "S"],
                },
                minDate: moment("2015-10-20"),
                maxDate: currentDate,
                ranges: {
                    'Last 7 Days': [currentDate.clone().subtract(6, 'days').startOf('day'), currentDate],
                    'Last 30 Days': [currentDate.clone().subtract(29, 'days').startOf('day'), currentDate],
                    'All Time': [moment("2015-10-20").startOf('day'), currentDate],
                },
                eventHandlers: {
                    'apply.daterangepicker': function(a,b) {
                    }
                }
            }
        };
        $scope.dateRangePicker2 = angular.copy($scope.dateRangePicker);
        $scope.dateRangePicker2.date = {startDate: null, endDate: null};
        $scope.dateRangePicker2.options.parentEl = "#dateRangePickerAttach";
        $scope.dateRangePicker2.options.pickerClasses = "inline";

        $scope.dateRangePickerSingle = {
            date: null,
            options: {
                showDropdowns: true,
                singleDatePicker: true,
                minDate: moment("2015-10-20"),
                maxDate: moment(),
            }
        };
        $scope.dateRangePickerSingle2 = angular.copy($scope.dateRangePickerSingle);
        $scope.dateRangePickerSingle2.options.autoApply = false;


        $scope.datePickerOptions = {minDate: moment().add(1, 'day').toDate(), maxDate: moment().add(30, 'days').toDate(), formatDayHeader: 'EEE', formatDay: 'd', showWeeks: false};
        $scope.datePickerValue = moment();




        $scope.setTableInfo = function() {
            var data = [];

            for (var i=0; i<10; i++) {
                data.push({
                    email: Math.random().toString(36).substring(Math.random()*7+3) + '@address.com',
                    date: new Date(new Date()*(Math.random()*0.5+0.5)),
                    status: ['cancelled','waiting','inactive','active'][Math.floor(Math.random()*4)],
                    value: Math.random() * 9000 + 1000
                });
            }

            $scope.pageData.tableParams = new NgTableParams({
                count: 4,
                sorting: {date: "desc"}
            }, {
                counts: [],
                // determines the pager buttons (left set of buttons in demo)
                paginationMaxBlocks: 7,
                paginationMinBlocks: 0,
                dataset: data
            });
            $scope.pageData.tableParams2 = new NgTableParams({
                count: 4,
                sorting: {date: "desc"}
            }, {
                counts: [2,4,8,12],
                // determines the pager buttons (left set of buttons in demo)
                paginationMaxBlocks: 7,
                paginationMinBlocks: 0,
                dataset: data
            });
        };
        $scope.setTableInfo();

        $scope.pageWidth = function() {
            return angular.element(window).outerWidth();
        };

        $scope.openModal = function(mClass = '', size = '', template = 'modal-style-guide-default.tpl.html') {
            let modalInstance = $uibModal.open({
                templateUrl: template,
                size: size,
                scope: $scope,
                windowClass: mClass
            });
            modalInstance.result.catch(angular.noop);

        };

        $scope.openThinking = function() {
            $scope.pageData.thinking = true;
            ThinkingService.open($scope, "styleGuideKey", {thinking:"Thinking about things for 2 sec", complete:"Done thinking now!"});
            $timeout(function() {
                $scope.pageData.thinking = false;
            }, 2000);
            $timeout(function() {
                ThinkingService.close(false, "styleGuideKey");
            }, 3000);

        };

        $scope.sendMessage = function(type='info', timeout=5, action='set') {

            if (timeout == 0) {
                timeout = false;
            }

            var data = {
                text: `Here's a friendly message reminding you to do something or other.  <a href="">Go here</a>.`,
                type: type,
                timeout: timeout
            };

            if (action !== 'set' && action !== 'add') action = 'set';
            Message[action](data);
        };

        $scope.alertClose = function(key) {
            $scope.pageData[key] = true;
        };

        $scope.changeOdometer = function() {
            $scope.options.odometer.initial = Math.floor(Math.random() * 2000000) + 10;
        };



        /**
         * Dynamically change the BS4 Classes if needed
         *
         * Adapted from:
         * https://themestr.app/theme#moreVars
         * would be super useful if they fixed their site
         *
         * @param choice
         */
        $scope.applyColor = function (choice) {
            $scope.selected.color = choice;
            var colors = $scope.options.colors;
            $(".style-guide-body").find('[class*="-primary"],[class*="-gold"],[class*="-secondary"],[class*="-danger"],[class*="-warning"],[class*="-info"],[class*="-success"],[class*="-light"],[class*="-dark"]').not(".toggles-ignore")
                .each(function (index, element) {
                    var $el = $(element);
                    var elColor = $el.attr("class");

                    for (var c in colors)
                        if (colors[c] !== choice) {
                            elColor = elColor.split("bg-" + colors[c]).join("bg-" + choice);
                            elColor = elColor.split("text-" + colors[c]).join("text-" + choice);
                            elColor = elColor.split("btn-outline-" + colors[c]).join("btn-outline-" + choice);
                            elColor = elColor.split("btn-" + colors[c]).join("btn-" + choice);
                            elColor = elColor.split("border-" + colors[c]).join("border-" + choice);
                            elColor = elColor.split("alert-" + colors[c]).join("alert-" + choice);
                            elColor = elColor.split("table-" + colors[c]).join("table-" + choice);
                            elColor = elColor.split("badge-" + colors[c]).join("badge-" + choice);
                        }
                    $el.attr("class", elColor);

                });
        };

}]);
